import { FC } from 'react';
import { useWizard } from 'react-use-wizard';
import { cx } from '@/utils/cx';

export type NewUnitWizardHeaderProps = {
  stepTitles: string[];
};

export const NewUnitWizardHeader: FC<NewUnitWizardHeaderProps> = ({
  stepTitles,
}) => {
  const { activeStep } = useWizard();

  return (
    <div className="mb-10 flex flex-row gap-8 border-b border-gray-900/10 py-6">
      {stepTitles.map((title, index) => (
        <div className="flex-grow" key={index}>
          <div
            className={cx(
              'flex flex-col border-t-4 border-gray-200 pt-5 text-sm font-medium',
              index <= activeStep && 'border-primary',
            )}
          >
            <div className="text-primary">{`Step ${index + 1}`}</div>
            <div>{title}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
